/**
 * Extract CSP nonce from the page
 * 
 * The nonce can be found in:
 * 1. Meta tag with name="csp-nonce" (recommended - server should inject this)
 * 2. Window variable set by server (window.__CSP_NONCE__)
 * 3. CSP header via meta tag (if server sets it)
 * 
 * Note: Browsers don't allow direct access to response headers via JavaScript
 * for security reasons, so the server must inject the nonce into the HTML.
 */

export const getCspNonce = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  
  // Method 1: Check window variable first (set by script in index.html)
  if (window.__CSP_NONCE__) {
    return window.__CSP_NONCE__;
  }
  
  if (typeof document === 'undefined') {
    return null;
  }
  
  // Method 2: Check for meta tag (server should inject this)
  const meta = document.querySelector('meta[name="csp-nonce"]');
  if (meta && meta.content && meta.content.trim()) {
    const nonce = meta.content.trim();
    // Make sure it's not a placeholder
    if (nonce && nonce !== '__CSP_NONCE__' && !nonce.includes('PLACEHOLDER')) {
      return nonce;
    }
  }
  
  // Method 3: Check for CSP header in meta tag (if server sets it)
  const cspMeta = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
  if (cspMeta && cspMeta.content) {
    // Extract nonce from style-src directive
    const styleSrcMatch = cspMeta.content.match(/style-src[^;]*nonce-([^'"]+)/);
    if (styleSrcMatch) {
      return styleSrcMatch[1];
    }
  }
  
  // Method 4: Try to read from all style tags and extract nonce
  // This is a fallback if nonce is already set on existing style tags
  const styleTags = document.querySelectorAll('style[nonce]');
  if (styleTags.length > 0) {
    const nonce = styleTags[0].getAttribute('nonce');
    if (nonce) {
      return nonce;
    }
  }
  
  return null;
};

